import React, { useEffect, useState } from 'react';
import './Modal.scoped.css'
import { CSSTransition } from 'react-transition-group';
import { define } from '../../../data/globals'

const Modal = ({visible, modalColors, header, pic, message, btn1Text, btn2Text, сonfirmed, hide}) => {
    const [btn1Color, setBtn1Color] = useState('blueBtn')
    const [btn2Color, setBtn2Color] = useState('blueBtn')
    const [picture, setPicture] = useState('')

    if(!btn2Text) btn2Text = 'Отмена'

    useEffect(()=>{
        switch(pic) {
            case 'alert':
                setPicture('/alert_48px.png')
                setBtn1Color('orangeBtn')
                setBtn2Color('orangeBtn')
                break
            case 'info':
                setPicture('/info_48px.png')
                setBtn1Color('blueBtn')
                setBtn2Color('blueBtn')
                break
            default:
                setPicture('')
                setBtn1Color('greenBtn')
                setBtn2Color('greenBtn')
                break
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div id="modal">
            <CSSTransition
                in={visible}
                timeout={500}
                classNames="fade"
                mountOnEnter
                unmountOnExit
            >
            <div className="dialog-bg"></div>
            </CSSTransition>

            <CSSTransition
                in={visible}
                timeout={500}
                classNames="slideV"
                mountOnEnter
                unmountOnExit
            >
            <div className="dialog-wrapper" onClick={ hide }>
                <div className="dialog__content" onClick={e => e.stopPropagation()}>
                    <div className={`header ${modalColors}`}>{ header }</div>
                    <div className='modal_flex'>
                        { (picture) ?
                            <img src={ define.pathToGraphics + picture } alt=''/>
                            : ''
                        } <div className="message" dangerouslySetInnerHTML={{ __html: message }} />
                    </div>
                    <div className="btns">
                    <button onClick={ сonfirmed }
                        className={`btn ${btn1Color}`}
                        >{ btn1Text }</button>
                    <button onClick={ hide }
                        className={`btn ${btn2Color}`}
                        >{ btn2Text }</button> 
                    </div>
                </div>
            </div>
            </CSSTransition>
        </div>
    )
}

export default Modal